import {
  ExpansionPanelProps,
  HistoryIcon,
  InfoCardList,
  InfoCardProps,
  SidebarExpansionPanel,
} from '@forgeglobal/design-framework'
import { formatAbbreviatedMoney } from 'util/NumberUtils'
import { useIssuerTradeHistoryQuery } from 'graphql/bindings/AdminBindings'
import React, { Fragment } from 'react'
import moment from 'moment'
import numeral from 'numeral'

interface TradeHistorySidebarPanelProps extends Omit<ExpansionPanelProps, 'children'> {
  accountId: string
}

const TradeHistorySidebarPanel: React.FC<TradeHistorySidebarPanelProps> = ({ accountId, ...props }) => {
  const { data } = useIssuerTradeHistoryQuery({ variables: { accountId: accountId } })
  const deals = data?.account?.issuer_account?.deals ?? []

  const dataList = deals.map<InfoCardProps>(deal => {
    const dateClosed = deal.dateClosed && moment(deal.dateClosed).format('M/D/YY')
    const { totalShares, netRevenue, averageTakeRate, numParticipants, grossPricePerShare } = deal
    const formattedRev = netRevenue ? formatAbbreviatedMoney(netRevenue) : 'No'

    return {
      leftTitle: dateClosed,
      leftSubtitle: `${numParticipants} participants`,
      rightTitle: formatAbbreviatedMoney(deal.totalVolume) || '–',
      rightSubtitle: `${numeral(grossPricePerShare).format('$0.00')} gross PPS`,
      notes: (
        <Fragment>
          <div>{numeral(totalShares).format('0,0')} shares</div>
          <div>{formattedRev} net revenue</div>
          <div>Average take rate {numeral(averageTakeRate).format('0.00%')}</div>
        </Fragment>
      ),
    }
  })

  return (
    <SidebarExpansionPanel icon={<HistoryIcon />} title="Trade History" {...props}>
      {!!dataList.length && <InfoCardList items={dataList} />}
    </SidebarExpansionPanel>
  )
}

export { TradeHistorySidebarPanel }
